<template>
  <div class="label" :style="css">
    {{text}}
  </div>
</template>

<script>
export default {
  props: {
    text: {
      type: String,
      default: 'new'
    },
    css: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  data () {
    return {

    }
  },
  methods: {

  }
}
</script>

<style lang="scss" scoped>
.label {
  min-width: 28px * 2;
  height: 14px * 2;
  border-radius: 16px 8px 16px 0;
  color: #fff;
  background-color: #ff4049;
  text-align: center;
  line-height: 14px * 2;
  font-size: 20px;
  transform: scale(0.5);
  transform-origin: 0 0;
}
</style>



// WEBPACK FOOTER //
// src/components/widgets/label.vue